module.exports = __webpack_public_path__ + "static/media/metacartel__hero.d567a91c.jpg";